<template>
    <div class="paper-layout">
        <el-container>
        <el-header>
            <img class="logo" src="../../static/logo1.jpg" />
            <div class="menu">
    
            </div>
            <div class="login_box">
                <span>{{ userinfo.name }}</span>
                <el-divider direction="vertical"></el-divider>
                <span @click="loginout" style="color: #409EFF;">退出</span>
            </div>
        </el-header>
        <el-main>
            <slot></slot>
        </el-main>
    </el-container>
    </div>
    
</template>
<script>
import axios from 'axios';
import Http from "../apis/user";
export default {
    data(){
        return{
            changeIndex:0,
            userinfo:{},
            avatar:''
        }
    },
    activated(){
        var userinfo = JSON.parse(localStorage.getItem('userinfo'))
        this.userinfo = userinfo
        this.avatar = axios.defaults.fileURL+userinfo.avatar
    },
    methods:{
        changeTable(index){
            this.changeIndex = index
        },

        loginout(){

            //
            Http.Logout().then((res) => {
                this.$message({
                    type: res.code?'success':'error',
                    message:res.msg
                });
                if(res.code){
                    localStorage.clear();
                    this.$router.push({ name: 'Login' });
                }
            });
        }
    }
}
</script>
<style lang="less" scoped>
.login_box{
    float: right;
    line-height: 60px;

    span{
        cursor: pointer;
    }
}

.paper-layout{
    width: 100%;
    height: 100%;

    .logo{
        float: left;
        height: 60px;
        
    }
    .el-header{
        background: #ffffff;
        margin-bottom: 20px;
    }

    .el-main{
        background: #ffffff;
        margin-left: 20px;
        margin-right: 20px;
    }
}
@media (max-width: 768px) {
    .el-main{
        overflow:hidden !important;
        padding-bottom: 60px;
        overflow-y: auto; /* 确保内容可以滚动 */
        -webkit-overflow-scrolling: touch; /* 启用iOS平滑滚动 */
    }
    .logo{
        float: left;
        margin-right: 0 !important;
        margin-left: 0 !important;
        margin-top: 0px !important;
        height: 60px;
    }
}

</style>